module.exports = __webpack_public_path__ + "media/images/icons/vendors/entertainment-9781296d6bc67ee35f08a6755becb826.png";